import React, { ReactElement } from "react";
import TopSalesReportList from "../../components/Reports/TopSalesProduct";
import MainLayout from "../../components/Layouts";

const TopSalesReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <TopSalesReportList />
    </MainLayout>
  );
}; 

export default TopSalesReportPage;
